import React from 'react'

export default function Landscapeop() {
  return (
    <div>
      Landscapeop
    </div>
  )
}
